export default __webpack_public_path__ + "static/media/IRON-ETH.7cef4227.png";